module.exports = __webpack_public_path__ + "static/media/hqx_paletas_2do.fdcd0350.jpg";